import { IApplicationState } from '../../types';
import { IAdminState } from '../reducer';

export const getAdminState = (state: IApplicationState): IAdminState =>
  state.admin;
